module.exports = __webpack_public_path__ + "static/media/3.0a7ad7ac.jpg";